'use client';

import {
  Drawer,
  HeaderWaffleMenu,
  Portal,
  useDrawer,
} from 'components/pcc-components';
import { ROOT_PORTALS } from 'constants/targets';
import { FC, PropsWithChildren } from 'react';
import { returnFocusToNavItem } from '../../utils/common-utils';

type WaffleMenuProps = { label: string; isMobile?: boolean };

export const WaffleMenuClient: FC<PropsWithChildren<WaffleMenuProps>> = ({
  label,
  children,
  isMobile = false,
}) => {
  const waffleID = isMobile ? 'headerWaffleMenuMobile' : 'headerWaffleMenu';
  const { initiatorProps, isDrawerOpen, drawerProps } = useDrawer({
    onClose: () => returnFocusToNavItem(`#${waffleID}`),
  });

  return (
    <>
      <HeaderWaffleMenu
        displayMobileNavLink={isMobile}
        handleDrawerProps={initiatorProps}
        id={waffleID}
        isCurrent={isDrawerOpen}
        text={label}
        title={label}
      />

      <Portal id={ROOT_PORTALS}>
        <Drawer {...drawerProps}>{children}</Drawer>
      </Portal>
    </>
  );
};
